import React from 'react'

import AddAdForm from '../../modules/Ad/components/AddAdForm'
export default function AddAdPage() {
  return (
    <AddAdForm/>  )
}
